import { isSsr } from './general';

export const getAuthorizationToken = (): string =>
  !isSsr ? window.THDCustomer?.default?.token || '' : '';

export const getSvocId = (): string | null =>
  isSsr ? null : window.THDCustomer?.default?.svocID || '';

export const getUserId = (): string | null =>
  isSsr ? null : window.THDCustomer?.default?.userID || '';

export const getMemberId = (): string | null => {
  if (isSsr) return null;

  const token = getAuthorizationToken();
  const svocId = getSvocId();

  if (token && svocId) return svocId;

  return window.THDCustomer?.default?.userID || '';
};

export const isLoggedIn = (): boolean =>
  window.THDCustomer?.default?.isLoggedIn || false;

export const getEmail = (): string | null => window.THDCustomer?.default?.email;

export const getCustomerIp = (): string => window.trueClientIp || '';
